module.exports = __webpack_public_path__ + "media/images/edit-b71022c227d43d27a5f8a4e12fa69fb0.svg";